export default __webpack_public_path__ + "static/past-c1d15dfc842e3cff1889bbe2db5a7d2e.svg";